import React from 'react';
import { AlertTriangle, X, ChevronDown, ChevronUp } from 'lucide-react';

interface CrashNotificationProps {
  content: string;
  onDismiss: () => void;
}

const CrashNotification: React.FC<CrashNotificationProps> = ({ content, onDismiss }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fade-in">
      <div className="bg-gray-900/95 rounded-2xl shadow-2xl border border-red-500/50 max-w-2xl w-full mx-4 overflow-hidden">
        {/* Header */}
        <div className="bg-red-900/30 px-6 py-4 flex items-center gap-3 border-b border-red-500/30">
          <AlertTriangle className="w-8 h-8 text-red-400 animate-pulse" />
          <div className="flex-1">
            <h2 className="text-xl font-bold text-red-400">Host Crash Detected</h2>
            <p className="text-sm text-red-300/80">The Host experienced a crash before this connection</p>
          </div>
          <button
            onClick={onDismiss}
            className="text-gray-400 hover:text-white transition-colors p-1"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Crash Log Preview/Full */}
        <div className="p-4">
          <div
            className={`bg-gray-950/80 rounded-lg p-4 font-mono text-xs overflow-auto border border-gray-700/50 ${
              isExpanded ? 'max-h-96' : 'max-h-32'
            }`}
          >
            <pre className="text-red-300/90 whitespace-pre-wrap">{content}</pre>
          </div>

          {/* Expand/Collapse button */}
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="mt-2 flex items-center gap-1 text-gray-400 hover:text-white text-sm transition-colors"
          >
            {isExpanded ? (
              <>
                <ChevronUp className="w-4 h-4" />
                Show less
              </>
            ) : (
              <>
                <ChevronDown className="w-4 h-4" />
                Show more
              </>
            )}
          </button>
        </div>

        {/* Actions */}
        <div className="px-6 py-4 bg-gray-800/30 flex justify-end gap-3 border-t border-gray-700/50">
          <button
            onClick={onDismiss}
            className="px-6 py-2.5 bg-red-600 hover:bg-red-500 text-white rounded-lg font-medium transition-colors shadow-lg"
          >
            I Know (Delete Log)
          </button>
        </div>
      </div>
    </div>
  );
};

export default CrashNotification;
